module.exports = __webpack_public_path__ + "static/media/edge_explode_polytope_5_3_3_cell120_layers_1_1.0a9bd5be.gif";